import {
    createActionCreator,
    createDeltaActionType,
    createSignalAction
} from '../../../setup-react';

// ===== Signals ============================================================ //

// Stats
export const FETCH_FEATURED_HEAD_TO_HEAD = createSignalAction(
    'statspro',
    'FETCH_FEATURED_HEAD_TO_HEAD'
);

// ===== Deltas ============================================================= //

// Stats
export const SET_FEATURED_HEAD_TO_HEAD = createDeltaActionType(
    'statspro',
    'SET_FEATURED_HEAD_TO_HEAD'
);
export const setFeaturedHeadToHead = createActionCreator(
    SET_FEATURED_HEAD_TO_HEAD
);
